import './faq.scss';
